import { __awaiter, __decorate } from "tslib";
import { Component, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { WebsiteThemeService } from '../../../services/website-theme.service';
import { Router } from "@angular/router";
import { ComponentService } from "../../../services/component.service";
import { WithdrawWalletModalComponent } from "../withdraw-wallet-modal/withdraw-wallet-modal.component";
import { LocationStrategy } from "@angular/common";
import { SharedHttp } from "../../../services/http-client.service";
import { ResetWalletPasswordModalComponent } from "../reset-wallet-password-modal/reset-wallet-password-modal.component";
import { InitiateDcaComponent } from "../initiate-dca/initiate-dca.component";
import { DepositOriginService } from '../../../services/deposit-origin.service';
import { isDepositOriginCode } from '../../../services/deposit-origin';
/**
 * Authentication Wallet Modal Component
 */
let AuthenticationWalletModalComponent = class AuthenticationWalletModalComponent {
    constructor(sanitizer, router, compService, location, httpClient, themeService, depositOriginService) {
        this.sanitizer = sanitizer;
        this.router = router;
        this.compService = compService;
        this.location = location;
        this.httpClient = httpClient;
        this.themeService = themeService;
        this.depositOriginService = depositOriginService;
        this.secondColor = '';
        this.successColor = '';
        this.borderRadiusSmaller = '';
        this.borderRadiusLarger = '';
        this.errorColor = '';
        this.walletPassword = '';
        this.validPassword = true;
        this.validMfa = true;
        this.sendButtonDisabled = true;
        this.code = [];
        this.user = JSON.parse(localStorage.getItem('user'));
        this.validCode = false;
        this.sendButtonClicked = false;
        this.withdrawError = false;
        this.errorMessage = '';
        this.showWalletPassword = false;
        this.mfaConfig = {
            allowNumbersOnly: true,
            length: 6,
            isPasswordInput: false,
            disableAutoFocus: true,
            placeholder: '.',
            inputClass: 'withdraw-mfa-input'
        };
        this.themeService.getTheme().subscribe((data) => {
            this.secondColor = this.themeService.getStyleAttribute('secondary_text_color');
            this.successColor = this.themeService.getStyleAttribute('success_color');
            this.borderRadiusSmaller = this.themeService.getStyleAttribute('border_radius_smaller');
            this.borderRadiusLarger = this.themeService.getStyleAttribute('border_radius_larger');
            this.errorColor = this.themeService.getStyleAttribute('error_color');
        });
        location.onPopState(() => {
            this.close();
        });
    }
    ngOnInit() {
    }
    close() {
        this.modal.destroy();
    }
    onMfaChange(mfaCode) {
        this.mfaCode = mfaCode;
        if (this.mfaCode.length < 6) {
            this.validCode = false;
            return;
        }
        this.validCode = true;
    }
    closeAndGoBack() {
        this.close();
        this.compService.openModal(WithdrawWalletModalComponent, {
            accountData: this.data.accountData,
            walletData: this.data.walletData
        });
    }
    sendCoinsOrFiat() {
        if (!this.validCode || !this.walletPassword) {
            return;
        }
        this.sendButtonClicked = true;
        this.withdrawError = false;
        this.validPassword = true;
        this.data.withdrawData.passphrase = this.walletPassword;
        this.data.withdrawData.mfaCode = this.mfaCode;
        let withdrawRoute = this.data.isFiat ? 'fiatwithdraw' : 'withdraw';
        this.httpClient.post('wallet/' + withdrawRoute, this.data.withdrawData).subscribe((data) => {
            this.data.authenticated = true;
            this.data.isSuccess = true;
        }, (error) => {
            this.sendButtonClicked = false;
            if (error.error['message'] === "MFA_NOT_VALID") {
                this.validCode = false;
                this.validMfa = false;
                return;
            }
            if (isDepositOriginCode(error.error.message)) {
                // the deposit trigger wants the statement or the proof of origin: its window instead of an error
                this.close();
                this.depositOriginService.openForCode(error.error.message);
                return;
            }
            if (error.error['message'][0] === 'WRONG_CUSTOMER_PASSPHRASE') {
                this.validPassword = false;
                this.errorMessage = null;
            }
            else {
                this.errorMessage = error.error['message'];
                this.withdrawError = true;
            }
        });
    }
    forgotPassword() {
        this.close();
        this.compService.openModal(ResetWalletPasswordModalComponent, {
            step: 1
        });
    }
    resendEmail() {
        return __awaiter(this, void 0, void 0, function* () {
            this.data = this.httpClient.post('wallet/forgotpassphrase', { fromWallet: true }).toPromise();
            this.close();
            this.compService.openModal(ResetWalletPasswordModalComponent, {
                step: 2
            });
        });
    }
    goToRecurringBuy() {
        this.close();
        this.compService.openModal(InitiateDcaComponent, {
            currency: this.data.currency,
            path: 'internal_buy'
        });
    }
};
AuthenticationWalletModalComponent.ctorParameters = () => [
    { type: DomSanitizer },
    { type: Router },
    { type: ComponentService },
    { type: LocationStrategy },
    { type: SharedHttp },
    { type: WebsiteThemeService },
    { type: DepositOriginService }
];
AuthenticationWalletModalComponent = __decorate([
    Component({
        selector: 'ecd-authentication-wallet-modal',
        encapsulation: ViewEncapsulation.None,
        template: __importDefault(require("./authentication-wallet-modal.component.html")).default
    })
], AuthenticationWalletModalComponent);
export { AuthenticationWalletModalComponent };
